import DemoLandingTemplate from '../../components/marketing/DemoLandingTemplate';
import type { DemoConfig } from '../../components/marketing/DemoLandingTemplate';

/* Demo landing page for Thomas Kielich Sr., CEO of National Bank Equipment
   Corporation (Buffalo, NY) — a physical bank-equipment vendor (ATMs, vaults,
   drive-up). NOT a compliance buyer, so the angle is a channel/referral
   relationship into their community-bank & credit-union clients. Facts verified
   2026-07-20; deliberately avoids: founding year (conflicting sources),
   "family-owned" (undocumented), and the unrelated Rockwall, TX "NBE". */
const config: DemoConfig = {
  docTitle: 'National Bank Equipment × Clarid — Demo',
  company: 'National Bank Equipment',
  firstName: 'Thomas',
  eyebrow: 'Prepared for your Clarid demo',
  headline: 'The compliance layer for the banks you already serve',
  lead: "National Bank Equipment keeps the physical branch running. Clarid handles the other side — the compliance and lending work those same community banks and credit unions manage every day. A natural addition to bring to the clients you already have.",
  fitHeadline: "You're already in the branch. Clarid belongs there too.",
  fitParagraphs: [
    'National Bank Equipment has spent years putting the physical infrastructure inside community banks and credit unions — ATMs, safes and vaults, drive-up systems, teller lines. You are a trusted vendor already inside the exact institutions Clarid was built for.',
    'Clarid handles the other half of the branch: the compliance and lending work those same institutions wrestle with every day — marketing review, HMDA, fair lending, CRA, and exam-ready packaging. It complements what you sell rather than competing with it.',
    'That makes for a clean partnership: you make the introduction to your bank and credit-union clients, the bank pays for the platform, and you earn a referral fee — deepening the relationships you already have, with no compliance work on your side.',
  ],
  agendaHeadline: "What we'll cover",
  agenda: [
    { title: 'A short platform tour', body: 'How a community bank runs marketing, HMDA, fair lending, and CRA in one connected system — and walks into an exam already packaged.' },
    { title: 'Where you fit', body: 'The referral / channel model: bank-always-pays, you earn a referral fee, and Clarid carries the technology relationship. A path Clarid already runs with other firms embedded in banks.' },
    { title: 'The introduction motion', body: 'What a warm intro to one of your bank or credit-union clients looks like, and exactly what Clarid handles from there so it never becomes work for you.' },
    { title: 'The economics', body: 'Referral terms, and how this compounds across the client base you already sell to.' },
  ],
  contact: {
    name: 'Bobby Sloan',
    title: 'Founder & CEO, Clarid',
    email: 'bobby@clarid.ai',
  },
};

export default function NbeDemoPage() {
  return <DemoLandingTemplate config={config} />;
}
